import { isTextNode } from 'anodum';
import textFormatting from '../../text-formatting';

const isLinkSelected = () => {
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { anchorNode, focusNode } = selection;

  const startElement = isTextNode(anchorNode) ? anchorNode.parentElement : anchorNode;
  const startLink = startElement ? startElement.closest('a') : null;

  const endElement = isTextNode(focusNode) ? focusNode.parentElement : focusNode;
  const endLink = endElement ? endElement.closest('a') : null;

  return Boolean(startLink && endLink && startLink === endLink);
};

export default isLinkSelected;
